export const BUSINESS_TYPES = [
  { value: "hair", label: "Hair Salon" },
  { value: "nails", label: "Nail Salon" },
  { value: "esthetics", label: "Esthetics / Skincare" },
  { value: "medspa", label: "Med Spa" },
  { value: "lashes", label: "Lashes & Brows" },
  { value: "massage", label: "Massage / Spa" },
  { value: "other", label: "Other beauty business" },
];

const PROVIDER_LABELS = {
  hair: "Stylist",
  nails: "Technician",
  esthetics: "Esthetician",
  medspa: "Provider",
  lashes: "Artist",
  massage: "Therapist",
  other: "Specialist",
};

export function providerLabel(businessType) {
  return PROVIDER_LABELS[businessType] || "Specialist";
}

export function providerLabelPlural(businessType) {
  const l = providerLabel(businessType);
  return l.endsWith("s") ? l : `${l}s`;
}

// Short prep-step prompt shown before a client books, tailored per industry.
const PREP_COPY = {
  hair: "So your stylist can prepare.",
  nails: "So your technician can prep the right products.",
  esthetics: "So we can tailor your treatment.",
  medspa: "So your provider can prepare.",
  lashes: "So your artist can prep the perfect look.",
  massage: "So your therapist can tailor your session.",
  other: "So we can prepare for your visit.",
};

export function prepCopy(businessType) {
  return PREP_COPY[businessType] || PREP_COPY.other;
}
